import { render, staticRenderFns } from "./SuccessPayment.vue?vue&type=template&id=47b50f90&scoped=true&"
import script from "./SuccessPayment.vue?vue&type=script&lang=js&"
export * from "./SuccessPayment.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPayment.vue?vue&type=style&index=0&id=47b50f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b50f90",
  null
  
)

export default component.exports